import en from "./en.json";
import ja from "./ja.json";
import kr from "./kr.json";
import validationEn from "./validationEn.json";
import validationJa from "./validationJa.json";
import validationKr from "./validationKr.json";

export const taascardLocales = { en, ja, kr };
export const taascardValidationLocales = { validationEn, validationJa, validationKr };
